var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "800px",
        fullscreen: _vm.$vuetify.breakpoint.xsOnly
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              return [
                _c(
                  "v-card",
                  {
                    staticClass: "d-flex flex-column",
                    attrs: { "min-height": "100%" }
                  },
                  [
                    _c("v-card-title", { staticStyle: { height: "64px" } }, [
                      _vm.editMode
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("company")) + " "),
                            _c("strong", [_vm._v(_vm._s(_vm.model.name))]),
                            _vm.model.number
                              ? _c("span", [
                                  _vm._v(" (" + _vm._s(_vm.model.number) + ")")
                                ])
                              : _vm._e()
                          ])
                        : _c("span", [_vm._v(_vm._s(_vm.$t("add_company")))])
                    ]),
                    _c(
                      "v-card-text",
                      { staticClass: "flex-grow-1" },
                      [
                        _c(
                          "v-form",
                          [
                            _c(
                              "v-container",
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "pb-0" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules:
                                              "required|verify:companies/verify?id=" +
                                              _vm.model.id,
                                            name: "name"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t("name"),
                                                        outlined: "",
                                                        dense: "",
                                                        "error-messages": errors,
                                                        hint: _vm.$t(
                                                          "required_field"
                                                        ),
                                                        "persistent-hint": "",
                                                        "hide-details": "auto",
                                                        disabled: _vm.isNameDisabled()
                                                      },
                                                      model: {
                                                        value: _vm.model.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "model.name"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "pt-0" },
                                      [
                                        _c("address-input", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            "with-country": true,
                                            disabled: _vm.isReadOnly()
                                          },
                                          model: {
                                            value: _vm.model.address,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression: "model.address"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-textarea", {
                                          attrs: {
                                            label: _vm.$t("comments"),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.model.remarks,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "remarks",
                                                $$v
                                              )
                                            },
                                            expression: "model.remarks"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "py-0" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            label: _vm.$t("manufacturer")
                                          },
                                          model: {
                                            value: _vm.model.isManufacturer,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "isManufacturer",
                                                $$v
                                              )
                                            },
                                            expression: "model.isManufacturer"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "py-0" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: { label: _vm.$t("supplier") },
                                          model: {
                                            value: _vm.model.isSupplier,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "isSupplier",
                                                $$v
                                              )
                                            },
                                            expression: "model.isSupplier"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "py-0" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: { label: _vm.$t("warehouse") },
                                          model: {
                                            value: _vm.model.isWarehouse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "isWarehouse",
                                                $$v
                                              )
                                            },
                                            expression: "model.isWarehouse"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "py-0" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: { label: _vm.$t("customer") },
                                          model: {
                                            value: _vm.model.isCustomer,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "isCustomer",
                                                $$v
                                              )
                                            },
                                            expression: "model.isCustomer"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "py-0" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: { label: _vm.$t("active") },
                                          model: {
                                            value: _vm.model.isEnabled,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "isEnabled",
                                                $$v
                                              )
                                            },
                                            expression: "model.isEnabled"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "px-7 pb-5" },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            staticClass: "primary--text",
                            attrs: { text: "" },
                            on: { click: _vm.cancel }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled: invalid,
                              loading: _vm.loading,
                              depressed: "",
                              color: "primary"
                            },
                            on: { click: _vm.confirm }
                          },
                          [
                            _vm.editMode
                              ? _c("span", [_vm._v(_vm._s(_vm.$t("save")))])
                              : _c("span", [_vm._v(_vm._s(_vm.$t("add")))])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }